import { AuthPageLayout } from '@/components/layouts';
import { LoginForm } from '@/pages/Login/LoginForm';

export const Login = () => (
  <AuthPageLayout>
    <LoginForm />
  </AuthPageLayout>
);
